import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useOrderBy = (
  defaultOrderBy = '',
  defaultSortOrder: 'asc' | 'desc' | '' = ''
) => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  useEffect(() => {
    let updated = false;

    if (!searchParams.has('order_by') && defaultOrderBy) {
      searchParams.set('order_by', defaultOrderBy);
      updated = true;
    }

    if (!searchParams.has('sort_order') && defaultSortOrder) {
      searchParams.set('sort_order', defaultSortOrder);
      updated = true;
    }

    if (updated) {
      navigate({ search: searchParams.toString() });
    }
  }, [defaultOrderBy, defaultSortOrder, navigate, searchParams]);

  // Get the 'order_by' and 'sort_order' values from the URL or use empty string if not set
  const orderBy = searchParams.get('order_by') || '';
  const sortOrder = searchParams.get('sort_order') || '';

  // Function to update both 'order_by' and 'sort_order' in the URL
  const setOrderBy = (newOrderBy: string, newSortOrder: 'asc' | 'desc') => {
    if (orderBy !== newOrderBy || sortOrder !== newSortOrder) {
      searchParams.set('order_by', newOrderBy);
      searchParams.set('sort_order', newSortOrder);
      navigate({ search: searchParams.toString() });
    }
    //
  };

  return { orderBy, sortOrder, setOrderBy };
};

export default useOrderBy;
